import { clx } from '@medusajs/ui';

interface StepperProps {
  steps?: string[];
  activeStep?: number;
}

const Stepper = ({ steps = ['1', '2', '3'], activeStep = 1 }: StepperProps) => {
  return (
    <div className="flex gap-4">
      {steps.map((step, index) => (
        <div key={step} className="flex items-center gap-4">
          <div className="flex flex-col items-center">
            <button
              disabled
              className={clx(
                'bg-grey-10 text-white-10 inline-block h-6 w-6 rounded-full font-bold lg:h-10 lg:w-10 lg:p-1',
                {
                  'bg-black-30': activeStep && index + 1 <= activeStep,
                }
              )}
            >
              {index + 1}
            </button>
            <span
              className={clx(
                'text-grey-10 mt-2 text-center text-sm font-normal lg:text-xl',
                {
                  'text-black-20': activeStep && index + 1 <= activeStep,
                }
              )}
            >
              {step}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={clx('bg-grey-10 mb-6 h-1 w-[200px]', {
                'bg-black-30': activeStep && index + 2 <= activeStep,
              })}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
